<template>
  <div
    class="q-pa-sm"
    :style="`background-color: #0000000d; border-radius: 5px; border-left: 3px solid ${borderColor}`"
    @click="$emit('click')"
  >
    <div
      :class="['text-weight-bold', 'text-left', senderColor]"
      v-if="senderName"
    >
      {{ senderName }}
    </div>
    <div class="row items-center text-grey-8 text-caption">
      <q-icon
        v-if="quoteDetails.icon"
        :name="quoteDetails.icon"
        class="q-mr-xs"
      />
      <span
        class="quote-text col text-left"
        v-html="formatQuoteText(quoteDetails.text)"
      />
    </div>
  </div>
</template>

<script>
import quoteMessageMixin from '@/mixins/quoteMessage'
import Helpers from '@/libs/helpers'

export default {
  name: 'BaseQuotedMessage',
  mixins: [quoteMessageMixin],
  props: {
    message: {
      type: Object,
      required: true
    },
    contactName: {
      type: String,
      default: ''
    }
  },
  methods: {
    formatQuoteText (text) {
      if (this.message?.type === 'TEXT') {
        return Helpers.formatMarkdownText(text)
      }
      return text
    }
  }
}
</script>

<style lang="sass" scoped>
.quote-text
  display: -webkit-box
  -webkit-line-clamp: 2
  -webkit-box-orient: vertical
  overflow: hidden
  text-overflow: ellipsis
  word-break: break-word
</style>
